import PropTypes from "prop-types";
import { mergeStyles } from "@react-spectrum/s2";
import { PrismLight, createElement } from "react-syntax-highlighter";
import json from "react-syntax-highlighter/dist/esm/languages/prism/json";
import markdown from "react-syntax-highlighter/dist/esm/languages/prism/markdown";

import { style } from "@react-spectrum/s2/style" with { type: "macro" };
import { prismStyles } from "./style";

PrismLight.registerLanguage("json", json);
PrismLight.registerLanguage("markdown", markdown);

function extendNode(node) {
  const styles = [];

  Object.entries(prismStyles).forEach(([type, className]) => {
    if (node?.properties?.className?.includes(type)) {
      styles.push(className);
    }
  });

  if (styles.length > 0) {
    node.properties.className.push(mergeStyles(...styles));
  }

  node?.children?.forEach?.(extendNode);

  return node;
}

function renderer({ rows, stylesheet, useInlineStyles }) {
  return rows.map((node, i) =>
    createElement({
      node: extendNode(node),
      stylesheet,
      useInlineStyles,
      key: `code-segment-${i}`,
    }),
  );
}

export const SyntaxHighlighter = ({
  language = "json",
  code,
  ...otherProps
}) => {
  return (
    <PrismLight
      language={language}
      useInlineStyles={false}
      wrapLongLines={true}
      codeTagProps={{
        className: style({
          font: {
            isCode: "code",
            default: "body",
          },
          whiteSpace: "pre-wrap",
        })({ isCode: language !== "markdown" }),
      }}
      renderer={renderer}
      {...otherProps}
    >
      {code}
    </PrismLight>
  );
};

SyntaxHighlighter.propTypes = {
  language: PropTypes.string,
  code: PropTypes.string.isRequired,
};
